import { getOrderItemProductName, getOrderItemProductVariantName, getOrderItemSku } from "~/cores/orderCore";
import styles from "./OrderItem.module.scss";
import { CopyOnClick } from "../copyText/CopyOnClick.jsx";
import React from "react";

export default function ({ orderItem }) {
    return (
        <div style={{ display: "flex", columnGap: "8px", flexWrap: "wrap" }}>
            <div className={styles["name"]}>{getOrderItemProductName({ orderItem })}</div>
            <div className={styles["variant"]}>{getOrderItemProductVariantName({ orderItem })}</div>
            <div className={styles["sku"]}>
                <CopyOnClick text={getOrderItemSku({ orderItem })} />
            </div>
        </div>
    );
}
